import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-customerform',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './customerform.component.html',
  styleUrl: './customerform.component.css'
})
export class CustomerformComponent {

  firstNameRepMatch: string = "";
  lastNameRepMatch: string = "";
  emailRepMatch: string = "";
  phoneRepMatch: string = "";
  companyRepMatch: string = "";
  titleRepMatch: string = "";
  cityRepMatch: string = "";
  stateRepMatch: string = "";
  zipRepMatch: string = "";
  marketsRepMatch: string = "";
  commentsRepMatch: string = "";
  golfRepMatch: boolean = false;
  lawnCareRepMatch: boolean = false;
  horticultureRepMatch: boolean = false;
  sportsTurfRepMatch: boolean = false;
  specialtyAgRepMatch: boolean = false;


  sendEmail() {
    const recipient = 'contact@harrells.com';
    const subject = "Harrell's - I'm Ready To Become A Customer!";
    const body = "Hello, I'm Ready To Become A Customer. \n \n " +  
    "First Name: " + this.firstNameRepMatch + " \n " +
    "Last Name: " + this.lastNameRepMatch + " \n " +
    "Company: " + this.companyRepMatch + " \n " +
    "Job Title: " + this.titleRepMatch + " \n \n " +
    "Email: " + this.emailRepMatch + " \n " +
    "Phone: " + this.phoneRepMatch + " \n " +
    "City: " + this.cityRepMatch + " \n " +
    "State: " + this.stateRepMatch + " \n " +
    "Zip: " + this.zipRepMatch + " \n " +
    "Golf: " + this.golfRepMatch.toString().replace('false','').replace('true','Yes') + " \n " +
    "Horticulture: " + this.horticultureRepMatch.toString().replace('false','').replace('true','Yes') + " \n " +
    "SportsTurf: " + this.sportsTurfRepMatch.toString().replace('false','').replace('true','Yes') + " \n " +
    "SpecialtyAg: " + this.specialtyAgRepMatch.toString().replace('false','').replace('true','Yes') + " \n " +
    "LawnCare: " + this.lawnCareRepMatch.toString().replace('false','').replace('true','Yes') + " \n \n " +
    "Comments: " + this.commentsRepMatch + " \n " 

    const mailtoUrl = `mailto:${recipient}?subject=${subject}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoUrl;

  }


}
